import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment.prod';
import { NotificationService } from '../../notification.service';
import { RestService } from '../../rest.service';
import { EncryptedDecryptedService } from '../../service/encrypted-decrypted.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public loginFormGroup: FormGroup;
  public result: boolean = true;
  public submitted: boolean = false;
  public employeeId: any;
  public url: any;
  constructor(private route: Router, private formBuilder: FormBuilder,
    private restService: RestService, private notify: NotificationService,
    private spinner: NgxSpinnerService, private activateRoute: ActivatedRoute,
    private encDecService: EncryptedDecryptedService )
     {
    this.loginFormGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }
  get email() { return this.loginFormGroup.get('email'); }
  get password() { return this.loginFormGroup.get('password'); }

  ngOnInit() {
    this.url = this.activateRoute.snapshot.params['url'];
    sessionStorage.setItem('loginUrl', this.url);
  }

  logIn() {
    this.submitted = true;
    if (this.loginFormGroup.invalid) {
      this.notify.showError('Please Fill All Required Fields!!', '');
      return;
    } else {
      this.spinner.show();
      const data = this.loginFormGroup.value;

        data.password = this.encDecService.set(
          "ln&t$ecretKeyG%C",
          this.loginFormGroup.get("password").value
        );

        data.email = this.encDecService.set(
        "ln&t$ecretKeyG%C",
        this.loginFormGroup.get("email").value
        );
      this.restService.postModel(this.loginFormGroup.value, '/screen/GetUser').subscribe((response) => {
        this.result = response.status;
        if (this.result) {
          this.restService.setUserLoggedIn(true);
          this.notify.showSuccess('Login Successfully!!', '');
          sessionStorage.setItem('userId', response.userId);
          sessionStorage.setItem('companyId', response.companyId);
          sessionStorage.setItem('employeeId', response.employeeId);
          sessionStorage.setItem('email', response.email);
          sessionStorage.setItem('roleId', response.roleId);
          sessionStorage.setItem('deptId', response.deptId);
          sessionStorage.setItem('name', response.name);
          sessionStorage.setItem('departmentName', response.departmentName);
          sessionStorage.setItem('roleName', response.roleName);
          sessionStorage.setItem('token', response.token);
          sessionStorage.setItem('companyId', response.companyId);
          sessionStorage.setItem('companyName', response.companyName);
          sessionStorage.setItem('projectId', response.projectId);
          this.route.navigateByUrl('/dashboard');
          this.employeeId = sessionStorage.getItem('employeeId');
          this.resetPivotData();
        } else {
          this.notify.showError('Invalid Credentials', '');
        }
        this.spinner.hide();
      });
    }
  }
  resetPivotData() {
    this.restService.model(`/config/deleteTestPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
    this.restService.model(`/config/deleteMitigationPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
    this.restService.model(`/config/deleteRiskPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
    this.restService.model(`/config/deleteIncidentPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
  }
}
